<template>
  <div>
    <div class="add-contract">
      <el-form :model="formData" class="form-data" :rules="rules" ref="formDataRef" label-width="130px">
        <el-form-item label="合同编号" prop="contractNo">
          <el-input v-model="formData.contractNo" disabled placeholder="根据编号规则自动生成"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerId">
          <select-customer @confirm="selctCustConfirm" :name="formData.customerName" :isReport="1" />
        </el-form-item>
        <el-form-item label="合同名称" prop="contractName">
          <el-input v-model="formData.contractName" placeholder="请输入合同名称" maxLength="100" clearable></el-input>
        </el-form-item>
        <el-form-item label="合同类型" prop="contractTypeId">
          <el-select v-model="formData.contractTypeId" placeholder="请选择合同类型" clearable @change="selectContractType">
            <el-option v-for="op in contTypeOptions" :key="op.id" :label="op.description" :value="op.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同金额" prop="contractAmount">
          <el-input v-model="formData.contractAmount" @change="refreshProcess" placeholder="请输入合同金额" maxLength="15" clearable></el-input>
        </el-form-item>
        <el-form-item label="签订日期" prop="signDate">
          <el-date-picker v-model="formData.signDate" clearable type="date" value-format="yyyy-MM-dd" placeholder="请选择合同签订日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同开始日期" prop="startDate">
          <el-date-picker v-model="formData.startDate" clearable type="date" value-format="yyyy-MM-dd" placeholder="请选择合同开始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束日期" prop="endDate">
          <el-date-picker v-model="formData.endDate" clearable type="date" value-format="yyyy-MM-dd" placeholder="请选择合同结束时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="联系人" prop="linkName">
          <el-input v-model.trim="formData.linkName" placeholder="请选择联系人" disabled>
            <el-button slot="append" @click="showSelectLinker">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="linkPhone">
          <el-input v-model="formData.linkPhone" placeholder="请选择联系人" disabled maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="chargeId">
          <input-staff :name="formData.chargeName" title="选择负责人" @confirmSelect="getStaff" />
        </el-form-item>
        <el-form-item label="所属部门" prop="chargeDeptId">
          <el-select v-model="formData.chargeDeptId" placeholder="选择负责人所属部门" clearable @change="selectDepartment">
            <el-option v-for="dep in departmentList" :key="dep.id" :label="dep.departmentName" :value="dep.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" class="full-width">
          <el-input v-model="formData.remark" rows="2" type="textarea" placeholder="请输入备注" maxLength="500" clearable></el-input>
        </el-form-item>
        <el-form-item label="附件" class="full-width">
          <upload-file-list :attachList="formData.attachList"></upload-file-list>
        </el-form-item>
        <el-form-item class="full-width" label="审批流程">
          <wf-create ref="wfCreate" v-if="$route.query.id ? formData.insId : true" :content="formData" :defId="formData.defID" :insId="formData.insId" processGroup="1" />
        </el-form-item>
        <el-form-item class="full-width">
          <el-button type="primary" @click="saveContract">保存</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <select-linker ref="selectLinkerRef" @confirmSelect="getLinker" />
  </div>
</template>

<script>
import { DictionaryApis, ContractApis, CustomerApis } from "@/apis";
import { DictionaryKey } from "@/utils/enum";
import SelectCustomer from "@/components/select-customer.vue";
import InputStaff from "@/components/input-staff.vue";
import SelectLinker from "@/components/select-linker.vue";
import { CommonService } from "@/service/common";
import UploadFileList from "@/views/components/upload-file-list.vue";
import WfCreate from "../work-flow/instance/create";
import dayjs from "dayjs";

export default {
  name: "add-contract",
  data() {
    return {
      rules: {
        customerId: [{ required: true, message: "请选择客户名称", trigger: "change" }],
        contractName: [{ required: true, message: "请输入合同名称", trigger: "change" }],
        contractTypeId: [{ required: true, message: "请选择合同类型", trigger: "change" }],
        contractAmount: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              CommonService.validatorAmount(value, callback, "请输入正确的合同金额");
            },
          },
        ],
        signDate: [{ required: true, message: "请选择签订日期", trigger: "change" }],
        startDate: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              const isAfter = dayjs(value).isAfter(this.formData.endDate);
              if (isAfter) callback("合同开始日期不能晚于合同结束日期");
              else callback();
            },
          },
        ],
        endDate: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              const isBefore = dayjs(value).isBefore(this.formData.startDate);
              if (isBefore) callback("合同结束日期不能早于合同开始日期");
              else callback();
            },
          },
        ],
        linkName: [{ required: true, message: "请选择联系人", trigger: "change" }],
        linkPhone: [{ required: true, message: "请选择联系人", trigger: "change" }],
        chargeId: [{ required: true, message: "请选择负责人", trigger: "change" }],
      },
      formData: {
        id: this.$route.query.id,
        customerId: "",
        customerName: "",
        contractNo: "",
        contractAmount: "",
        contractName: "",
        signDate: "",
        startDate: "",
        endDate: "",
        contractTypeId: "",
        contractTypeName: "",
        linkName: "",
        linkPhone: "",
        chargeId: "",
        chargeName: "",
        chargeDeptId: "", // 负责人名称
        chargeDeptName: "",
        remark: "",
        attachList: [],
        insId: 0,
        defID: 0,
      },
      departmentList: [],
      contTypeOptions: [],
    };
  },
  created() {
    this.initBreadcrumb();
    this.getTypeOptions();
    if (this.formData.id) this.getContractInfo();
  },
  methods: {
    refreshProcess() {
      this.$refs.wfCreate.$refresh();
    },
    initBreadcrumb() {
      // 处理breadcrumb
      const curBread = this.$store.state.breadcrumb.find((i) => i.path === "/add-contract");
      if (curBread) curBread.title = this.formData.id ? "修改合同" : "新建合同";
    },
    getContractInfo() {
      ContractApis.getContractById(this.formData.id).then((res) => {
        this.getChargeDepart(res.chargeId);
        for (const key in this.formData) {
          if (res[key]) this.formData[key] = res[key];
        }
      });
      ContractApis.getContractAttachs(this.formData.id).then((res) => {
        this.formData.attachList = res;
      });
    },
    getTypeOptions() {
      DictionaryApis.getDictValueByKey(DictionaryKey.ContractType).then((res) => {
        this.contTypeOptions = res;
      });
    },
    show(row) {
      if (row) {
        for (const key in this.formData) {
          this.formData[key] = row[key];
        }
      }
    },
    // 选择客户
    selctCustConfirm(row) {
      this.formData.customerId = row.id;
      this.formData.customerName = row.customerName;
    },
    // 选择合同类型
    selectContractType(id) {
      this.formData.contractTypeName = this.contTypeOptions.find((i) => i.id === id).description;
      this.refreshProcess();
    },
    getStaff(staff) {
      this.formData.chargeId = staff.id;
      this.formData.chargeName = staff.realName;
      if (!staff.departmentList || !staff.departmentList.length) {
        staff.departmentList = [{ id: "0", departmentName: "总公司" }]; // 没有部门时要处理成总公司
      }
      this.formData.chargeDeptId = staff.departmentList[0].id;
      this.formData.chargeDeptName = staff.departmentList[0].departmentName;
      this.departmentList = staff.departmentList;
    },
    selectDepartment(depid) {
      const dep = this.departmentList.find((d) => depid === d.id);
      this.formData.chargeDeptId = dep.id;
      this.formData.chargeDeptName = dep.departmentName;
    },
    async getChargeDepart(chargeId) {
      if (chargeId) {
        let res = await this.$axios.get(`/Crm/Department/DepartmentByUId?userId=${chargeId}`);
        if (!res.length) res = [{ id: "0", departmentName: "总公司" }];
        this.departmentList = res;
      }
    },
    //选择联系人
    showSelectLinker() {
      if (!this.formData.customerId) {
        return this.$message.warning("请先选择客户");
      }
      CustomerApis.getLinksByCustomerId(this.formData.customerId).then((res) => {
        if (res || res.length) {
          this.$refs.selectLinkerRef.open(res);
        } else {
          this.$message.warning("这是旧数据，请删除！");
        }
      });
    },
    // 选择联系人
    getLinker(row) {
      // this.formData.linkId = row.id;
      this.formData.linkName = row.linkName;
      this.formData.linkPhone = row.linkPhone;
    },
    async saveContract() {
      await this.$refs.formDataRef.validate();
      if (this.formData.id > 0) {
        await ContractApis.editContract(this.formData);
        // this.$message.success("修改成功");
      } else {
        const res = await ContractApis.addContract(this.formData);
        // this.$message.success("新增成功");
        this.formData.id = res;
      }
      this.$refs.wfCreate.submit(this.formData.id);
      this.$router.back();
    },
  },
  components: { SelectCustomer, InputStaff, SelectLinker, UploadFileList, WfCreate },
};
</script>

<style scoped lang="scss">
.add-contract {
  flex: 1;
  overflow: auto;
  padding-right: 10px;
  .el-form {
    width: 100%;
    max-width: 1000px;
  }
}
</style>
